import { render, staticRenderFns } from "./userAccount.vue?vue&type=template&id=2e1edd8d&scoped=true&"
import script from "./userAccount.vue?vue&type=script&lang=js&"
export * from "./userAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1edd8d",
  null
  
)

export default component.exports